export default (callSign: string) => {
  const snippet =
    `// Without JQuery
    var player = new MediaElement('player', {});

    ra("${callSign}", {
        mediaElement: {
          instance: player,
        },
    });

    // With JQuery
    $('#player').mediaelementplayer({
        success: function(mediaElement, originalNode, instance) {
          window.mediaelement = mediaElement;
        }
    });


    ra("${callSign}", {
      mediaElement: {
        instance: window.mediaelement,
      },
    });`;

  return snippet;
};



// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/content/radioAnalytics/snippets/mediaElementSnippet.js